export function externalShipmentAffLocationScannedValidate(scanned) {
    var result = true; 
    var errors = [];

    result = validateType(scanned.type, errors);
    result = validateLocationId(scanned.location_id, errors);
    result = validateLocationName(scanned.location_name, errors);
    result = validateStatus(scanned.status, errors);
    result = validateProducts(scanned.products, errors);
    
    if(!result) return errors;
    else return result;
}

function validateType(type, errors) {
    if(typeof type === 'string' && type.trim() !== '') return true;
    else {
        errors.push("type_not_valid");
        return false;
    } 
}

function validateLocationId(location_id, errors){    
    if(Number.isInteger(location_id)) return true;
    else { 
        errors.push("location_id_not_valid");
        return false;
    }
}

function validateLocationName(location_name, errors) {
    if(typeof location_name === 'string' && location_name.trim() !== '') return true;
    else {
        errors.push("location_name_not_valid");
        return false;
    } 
}

function validateStatus(status, errors) {
    if(typeof status === 'string' && status.trim() !== '') return true;
    else {
        errors.push("status_not_valid");
        return false;
    } 
}

function validateProducts(products, errors) {
    if (Array.isArray(products) 
    && products.length > 0 
     && products.every(item =>
        typeof item === 'object' &&
        item !== null &&
        typeof item.product_id === 'number' &&
        !isNaN(item.product_id) &&
        typeof item.detailed_stock_id === 'number' &&
        !isNaN(item.detailed_stock_id)&&
        typeof item.unit_price === 'number' &&
        !isNaN(item.unit_price) &&
        typeof item.sku === "string" &&
        item.sku !== '' &&
        typeof item.product_line === "string" &&
        item.product_line !== '' &&
        typeof item.reference === "string" &&
        item.reference !== '' &&
        typeof item.batch === "string" &&
        item.batch !== '' &&
        typeof item.pallet === 'number' &&
        !isNaN(item.pallet) &&
        typeof item.required === 'number' &&
        !isNaN(item.required) &&
        typeof item.scanned === 'number' &&
        !isNaN(item.scanned) 
    )) return true;
    else {
        errors.push("products_not_valid")
        return false;
    }
}